<template>
  <div>
    <div class="page-head"><div><h2>协议版本管理</h2><p>发布新版本后旧版本自动归档，用户登录只可同意当前生效版本。</p></div></div>
    <el-row :gutter="18">
      <el-col v-for="type in types" :key="type.key" :span="12">
        <el-card shadow="never">
          <div slot="header" class="card-head"><span>{{ type.label }}</span><el-tag v-if="current(type.key)" type="success">当前 {{ current(type.key).version }}</el-tag></div>
          <el-form label-width="90px">
            <el-form-item label="新版本号"><el-input v-model="forms[type.key].version" placeholder="例如 2026.08.01" /></el-form-item>
            <el-form-item label="标题"><el-input v-model="forms[type.key].title" /></el-form-item>
            <div v-for="(section, index) in forms[type.key].sections" :key="index" class="section-editor">
              <el-form-item :label="`章节 ${index + 1}`"><el-input v-model="section.title" placeholder="章节标题" /></el-form-item>
              <el-form-item label="正文"><el-input v-model="section.paragraphsText" type="textarea" :rows="4" placeholder="每段一行" /></el-form-item>
              <el-button v-if="forms[type.key].sections.length > 1" type="text" class="remove" @click="removeSection(type.key, index)">删除本章</el-button>
            </div>
            <el-button size="small" @click="addSection(type.key)">增加章节</el-button>
            <el-button type="primary" size="small" :loading="publishing === type.key" @click="publish(type.key)">发布新版本</el-button>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <el-card shadow="never" class="history-card">
      <div slot="header">历史版本</div>
      <el-table :data="rows" v-loading="loading">
        <el-table-column prop="agreement_type" label="类型" width="100"><template slot-scope="{ row }">{{ row.agreement_type === 'user' ? '用户协议' : '隐私政策' }}</template></el-table-column>
        <el-table-column prop="version" label="版本" width="150" />
        <el-table-column prop="title" label="标题" />
        <el-table-column prop="status" label="状态" width="110"><template slot-scope="{ row }"><el-tag :type="row.status === 'published' ? 'success' : 'info'">{{ row.status === 'published' ? '当前生效' : '历史归档' }}</el-tag></template></el-table-column>
        <el-table-column prop="published_at" label="发布时间" width="190" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import http from "../api/http";

function emptyForm(title) { return { version: "", title, sections: [{ title: "", paragraphsText: "" }] }; }

export default {
  name: "AgreementVersionsManage",
  data() {
    return {
      types: [{ key: "user", label: "用户协议" }, { key: "privacy", label: "隐私政策" }],
      rows: [], loading: false, publishing: "",
      forms: { user: emptyForm("用户协议"), privacy: emptyForm("隐私政策") }
    };
  },
  mounted() { this.fetchList(); },
  methods: {
    current(type) { return this.rows.find((row) => row.agreement_type === type && row.status === "published"); },
    toForm(row, title) {
      return {
        version: "", title: row ? row.title : title,
        sections: row && row.content && row.content.length
          ? row.content.map((item) => ({ title: item.title, paragraphsText: (item.paragraphs || []).join("\n") }))
          : [{ title: "", paragraphsText: "" }]
      };
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await http.get("/agreement-versions");
        this.rows = (res.data && res.data.items) || [];
        this.forms.user = this.toForm(this.current("user"), "用户协议");
        this.forms.privacy = this.toForm(this.current("privacy"), "隐私政策");
      } finally { this.loading = false; }
    },
    addSection(type) { this.forms[type].sections.push({ title: "", paragraphsText: "" }); },
    removeSection(type, index) { this.forms[type].sections.splice(index, 1); },
    async publish(type) {
      const form = this.forms[type];
      const content = form.sections.map((section) => ({
        title: section.title.trim(),
        paragraphs: section.paragraphsText.split("\n").map((item) => item.trim()).filter(Boolean)
      }));
      if (!form.version.trim() || content.some((item) => !item.title || !item.paragraphs.length)) {
        this.$message.error("请填写版本号，并完整填写每个章节的标题和正文"); return;
      }
      await this.$confirm("发布后当前版本将归档，登录用户必须同意新版本。确认发布吗？", "发布协议", { type: "warning" });
      this.publishing = type;
      try {
        await http.post("/agreement-versions/publish", { agreement_type: type, version: form.version.trim(), title: form.title.trim(), content });
        this.$message.success("新协议版本已发布");
        await this.fetchList();
      } finally { this.publishing = ""; }
    }
  }
};
</script>

<style scoped>.card-head{display:flex;justify-content:space-between;align-items:center}.section-editor{position:relative;padding:14px 8px 4px;margin-bottom:14px;background:#f7f8fa;border-radius:6px}.remove{position:absolute;right:14px;top:5px}.history-card{margin-top:18px}</style>
